module.exports = __webpack_public_path__ + "img/202311_02.73b85509.jpg";